export const FOOTER_ROUTES = [
    { label: 'Documentation',           path: '/documentation' },
    { label: 'Support',                   path: '/support' },
    { label: 'Privacy & Terms',           path: '/privacy-terms' },
    { label: 'Sitemap',                   path: '/sitemap' },
    { label: 'Customers',                 path: '/customers' },
    { label: 'Home',                      path: '/' },
    { label: 'About Us',                  path: '/about-us' },
    { label: 'Business Partnership',      path: '/business-partnership' },
    { label: 'Blogs',                     path: '/blogs' },
    { label: 'Contact Us',                path: '/contact-us' },
    { label: 'Privacy Policy',            path: '/privacy-policy' },
    { label: 'Terms and Conditions',      path: '/terms-and-conditions' },
    { label: 'Return Policy',             path: '/return-policy' },
    { label: 'Refund Policy',             path: '/refund-policy' },
    { label: 'IP Policy',                 path: '/ip-policy' },
];

export const FOOTER_PATHS = FOOTER_ROUTES.reduce((acc, { label, path }) => {
    if (path !== '/') acc[path] = label;
    return acc;
}, {});

export const isFooterPath = (pathname) => pathname in FOOTER_PATHS;

export const FOOTER_LINK_MAP = FOOTER_ROUTES.reduce((acc, { label, path }) => {
    acc[label] = path;
    return acc;
}, {});
